export function summarizeComputeResult(summary: string): string | null {
	try {
		const j = JSON.parse(summary) as {
			description?: string;
			success?: boolean;
		};
		const desc = (j.description ?? "").trim();
		if (j.success === false) {
			return desc ? `Could not complete: ${desc}.` : "Computation failed.";
		}
		return desc || null;
	} catch {
		return null;
	}
}
